<template>
  <div>
    <div
      class="flex flex-row items-center px-2 py-1 cursor-pointer rounded hover:bg-gray-100"
      :style="{ paddingLeft: `${(depth + 1) * 12}px` }"
      :class="{
        'bg-primary-100 text-primary font-medium': selectedFolderId === folder.ID,
        'bg-blue-100 border border-blue-300': highlightedFolderId === folder.ID || isDragOver,
      }"
      :data-folder-id="folder.ID"
      @click="$emit('folderSelected', folder.ID)"
      @dragover.prevent="isDragOver = true"
      @dragleave="isDragOver = false"
      @drop.prevent="onDrop"
    >
      <font-awesome-icon
        v-if="childFolders.length > 0"
        :icon="isExpanded ? 'chevron-down' : 'chevron-right'"
        class="mr-1 text-xs text-gray-400"
        @click.stop="$emit('toggleExpand', folder.ID)"
      />
      <font-awesome-icon v-else icon="folder" class="mr-2 text-sm text-primary" />
      <p class="text-sm">{{ folder.Name }}</p>
    </div>
    <template v-if="isExpanded">
      <FolderNode
        v-for="child in childFolders"
        :key="child.ID"
        :folder="child"
        :folders="folders"
        :selectedFolderId="selectedFolderId"
        :highlightedFolderId="highlightedFolderId"
        :expandedIds="expandedIds"
        :depth="depth + 1"
        @folderSelected="(id) => $emit('folderSelected', id)"
        @toggleExpand="(id) => $emit('toggleExpand', id)"
        @itemDropped="(id) => $emit('itemDropped', id)"
      />
    </template>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

const props = defineProps({
  folder: Object,
  folders: Array,
  selectedFolderId: [String, null],
  highlightedFolderId: [String, null],
  expandedIds: Object,
  depth: { type: Number, default: 0 },
});

const emit = defineEmits(["folderSelected", "toggleExpand", "itemDropped"]);

const isDragOver = ref(false);

const onDrop = () => {
  isDragOver.value = false;
  emit("itemDropped", props.folder.ID);
};

const childFolders = computed(() => {
  return (props.folders || []).filter((f) => f.Parent === props.folder.ID);
});

const isExpanded = computed(() => {
  return props.expandedIds?.has(props.folder.ID) || props.selectedFolderId === props.folder.ID;
});
</script>
